import * as React from 'react'
import useStyles from './drawer.css'

const DrawerComponent: React.FC = ({ children }) => {
    const classes = useStyles()
    return <div className={classes.root}>{children}</div>
}

export default DrawerComponent
